import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCanAccess } from '../hooks/useCanAccess';

/**
 * Renders children only if the user has the given pharmacy permission; otherwise redirects to dashboard.
 * Use for admin-only or permission-gated screens (e.g. Manage access, Banking, Settings).
 */
const PermissionRoute: React.FC<{ permission: string; children: React.ReactNode }> = ({ permission, children }) => {
  const canAccess = useCanAccess(permission);
  if (!canAccess) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default PermissionRoute;
